export const queryStringBuilder = (query: { [x: string]: any }) => {
  let queryString: string = '';

  Object.keys(query).map((prop) => {
    if (query[prop] != null && typeof query[prop] !== 'undefined') {
      if (Array.isArray(query[prop]) && query[prop].length > 0) {
        queryString = query[prop]
          .map((m: any) => {
            if (typeof m !== 'undefined') queryString += `${prop}=${m}&`;
          })
          .join('');
      } else if (!Array.isArray(query[prop])) {
        queryString += `${prop}=${query[prop]}&`;
      }
    }
  });

  queryString = queryString.substring(0, queryString.length - 1);

  return queryString;
};
